<template>
  <card
    @onRemoveItem="handleRemove"
    :item="item"
    model="grouping"
    :image="imagePath"
    :user="user"
    :url="url"
  >
    <CardItemList>
      <CardDetail
        :key="detail.label"
        v-for="detail in details"
        :label="detail.label"
        :val="detail.val"
        :url="detail.url"
      />
      <CardDetail
        label="Sold In"
        :val="item.countries"
        field="name"
        url="/country/"
      />
      <CardDetail
        label="Number of Ponies"
        :val="`${item.num_ponies} ${plural('Pony', item.num_ponies)}`"
      />
    </CardItemList>
    <div>
      <h3 class="card-details-title">Ponies:</h3>
      <ul v-if="ponies && ponies.length" class="card-details card-list">
        <li class="card-list-item" :key="item.slug" v-for="item in ponies">
          <router-link :to="`/pony/${item.slug}`">{{item.name}}</router-link> <span class="elr-text-success">{{(item.inHerd) ? '&check;'  : ''}}</span>
        </li>
      </ul>
    </div>
  </card>
</template>

<script>
import { capitalize, getImagePath, plural, slugify } from '../../utils/helpers';
import Card from '../Card/Card';
import CardDetail from '../CardDetail/CardDetail'
import CardItemList from '../CardItemList/CardItemList'

export default {
  name: 'GroupCard',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Card,
    CardDetail,
    CardItemList
  },
  data() {
    return {
    }
  },
  computed: {
    details() {
      return [
        {
          label: 'Generation',
          val: capitalize(this.item.generation?.name),
          url: `/generation/${this.item.generation?.slug}`
        },
        {
          label: 'Brand',
          val: capitalize(this.item.brand?.name),
          url: `/brand/${this.item.brand?.slug}`
        },
        {
          label: 'Year',
          val: capitalize(this.item.year?.year_made),
          url: `/year/${this.item.year?.slug}`
        },
        {
          label: 'Origin',
          val: capitalize(this.item.origin?.name),
          url: `/origin/${this.item.origin?.slug}`
        },
        {
          label: 'Manufacturer',
          val: capitalize(this.item.manufacturer?.name),
          url: `/manufacturer/${this.item.manufacturer?.slug}`
        },
        {
          label: 'Release',
          val: capitalize(this.item.release?.name),
          url: `/release/${this.item.release?.slug}`
        }
      ]
    },
    imagePath() {
      return getImagePath(this.item?.image);
    },
    ponies() {
      return this.item.ponies?.items ? this.item.ponies?.items : [];
    },
    url() {
      return `/grouping/${this.item?.slug}`
    },
  },
  methods: {
    slugify,
    handleRemove() {
      this.$emit('onRemove', {slug: this.item.slug});
    },
    plural,
  }
};
</script>

<style lang="scss" scoped>
ul.group-details {
  border-bottom: 1px solid #ccc;
  padding-left: 5px;
  margin-bottom: 10px;
}

ul.card-details {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  list-style: none;
}

.card-item-header + ul.card-details {
  padding-top: 0;
}

.card-list-item {
  font-size: 14px;
  padding: 5px 0;
}
</style>
